module.exports = __webpack_public_path__ + "media/images/e-bilet/train_small-adef6b20932da6d04ed8932823c14923.svg";